/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMessageBulkPost } from '../fn/message/api-message-bulk-post';
import { ApiMessageBulkPost$Params } from '../fn/message/api-message-bulk-post';
import { apiMessageCsvPost } from '../fn/message/api-message-csv-post';
import { ApiMessageCsvPost$Params } from '../fn/message/api-message-csv-post';
import { apiMessageFileFileIdGet } from '../fn/message/api-message-file-file-id-get';
import { ApiMessageFileFileIdGet$Params } from '../fn/message/api-message-file-file-id-get';
import { apiMessageMessageIdDelete } from '../fn/message/api-message-message-id-delete';
import { ApiMessageMessageIdDelete$Params } from '../fn/message/api-message-message-id-delete';
import { apiMessagePost } from '../fn/message/api-message-post';
import { ApiMessagePost$Params } from '../fn/message/api-message-post';
import { apiMessageValidateAiCorrectionItemIdPost } from '../fn/message/api-message-validate-ai-correction-item-id-post';
import { ApiMessageValidateAiCorrectionItemIdPost$Params } from '../fn/message/api-message-validate-ai-correction-item-id-post';
import { FileUrl } from '../models/file-url';
import { ImportResponseList } from '../models/import-response-list';
import { Message } from '../models/message';


/**
 * Message service
 */
@Injectable({ providedIn: 'root' })
export class MessageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMessagePost()` */
  static readonly ApiMessagePostPath = '/api/message';

  /**
   * Create a message as user/student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessagePost()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiMessagePost$Response(params: ApiMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Message>> {
    return apiMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a message as user/student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessagePost$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiMessagePost(params: ApiMessagePost$Params, context?: HttpContext): Observable<Message> {
    return this.apiMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Message>): Message => r.body)
    );
  }

  /** Path part for operation `apiMessageFileFileIdGet()` */
  static readonly ApiMessageFileFileIdGetPath = '/api/message/file/{file_id}';

  /**
   * Download a file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessageFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMessageFileFileIdGet$Response(params: ApiMessageFileFileIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
    return apiMessageFileFileIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Download a file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessageFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMessageFileFileIdGet(params: ApiMessageFileFileIdGet$Params, context?: HttpContext): Observable<FileUrl> {
    return this.apiMessageFileFileIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUrl>): FileUrl => r.body)
    );
  }

  /** Path part for operation `apiMessageBulkPost()` */
  static readonly ApiMessageBulkPostPath = '/api/message/bulk';

  /**
   * Sync messages form an array of messages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessageBulkPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMessageBulkPost$Response(params: ApiMessageBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
    return apiMessageBulkPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync messages form an array of messages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessageBulkPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMessageBulkPost(params: ApiMessageBulkPost$Params, context?: HttpContext): Observable<ImportResponseList> {
    return this.apiMessageBulkPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResponseList>): ImportResponseList => r.body)
    );
  }

  /** Path part for operation `apiMessageCsvPost()` */
  static readonly ApiMessageCsvPostPath = '/api/message/csv';

  /**
   * Upload a CSV file, parse the file and import the messages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessageCsvPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMessageCsvPost$Response(params: ApiMessageCsvPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
    return apiMessageCsvPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a CSV file, parse the file and import the messages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessageCsvPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMessageCsvPost(params: ApiMessageCsvPost$Params, context?: HttpContext): Observable<ImportResponseList> {
    return this.apiMessageCsvPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResponseList>): ImportResponseList => r.body)
    );
  }

  /** Path part for operation `apiMessageMessageIdDelete()` */
  static readonly ApiMessageMessageIdDeletePath = '/api/message/{message_id}';

  /**
   * Delete a message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessageMessageIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMessageMessageIdDelete$Response(params: ApiMessageMessageIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiMessageMessageIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessageMessageIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMessageMessageIdDelete(params: ApiMessageMessageIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiMessageMessageIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiMessageValidateAiCorrectionItemIdPost()` */
  static readonly ApiMessageValidateAiCorrectionItemIdPostPath = '/api/message/validate-ai-correction/{item_id}';

  /**
   * Validate an automatic correction of a message.
   *
   * Args:
   * - item_id (int): The ID of the message for which the AI correction is being validated.
   * - args (dict): A dictionary containing the following keys:
   *     - correction_message (str): The message containing the correction information to be validated.
   *     - correction_qualification (float): The qualification or grade associated with the correction.
   *     - reopen_activity (bool): Whether to reopen the activity associated with the correction.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMessageValidateAiCorrectionItemIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMessageValidateAiCorrectionItemIdPost$Response(params: ApiMessageValidateAiCorrectionItemIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiMessageValidateAiCorrectionItemIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Validate an automatic correction of a message.
   *
   * Args:
   * - item_id (int): The ID of the message for which the AI correction is being validated.
   * - args (dict): A dictionary containing the following keys:
   *     - correction_message (str): The message containing the correction information to be validated.
   *     - correction_qualification (float): The qualification or grade associated with the correction.
   *     - reopen_activity (bool): Whether to reopen the activity associated with the correction.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMessageValidateAiCorrectionItemIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMessageValidateAiCorrectionItemIdPost(params: ApiMessageValidateAiCorrectionItemIdPost$Params, context?: HttpContext): Observable<void> {
    return this.apiMessageValidateAiCorrectionItemIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
